import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

import { computed, useSlots } from "vue";
import { ModalProps } from "@/types";
import { Typography, Separator, FlexBox } from "@/components/common/display";
import { IconButton } from "@/components/common/button";


/**
 * Displays a generic modal.
 */
const __default__ = {
  name: "Modal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    subtitle: {},
    open: { type: Boolean },
    size: {},
    loading: { type: Boolean },
    dataCy: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();

const className = computed(() => `modal-${props.size}`);

return (_ctx: any,_cache: any) => {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": props.open,
    "data-cy": props.dataCy,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    onHide: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(className.value)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_unref(FlexBox), {
                "full-width": "",
                justify: "between",
                align: "center",
                "data-cy": "modal-title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Typography), {
                    value: props.title
                  }, null, 8, ["value"]),
                  _createVNode(_unref(IconButton), {
                    tooltip: "Close",
                    icon: "cancel",
                    "data-cy": "button-close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(Separator)),
              (props.loading)
                ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                    key: 0,
                    indeterminate: ""
                  }))
                : _createCommentVNode("", true),
              (!!props.subtitle)
                ? (_openBlock(), _createBlock(_unref(Typography), {
                    key: 1,
                    t: "2",
                    b: "",
                    el: "p",
                    value: props.subtitle
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (!!_unref(slots).default)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          (!!_unref(slots).actions)
            ? (_openBlock(), _createBlock(_component_q_card_actions, {
                key: 1,
                align: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Separator)),
                  _renderSlot(_ctx.$slots, "actions")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }, 8, ["model-value", "data-cy"]))
}
}

})